import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

class ToggleMenu extends Class {

	constructor(element, options){
		super();
		this.setOptions(options);
		this.setUpElements(element);
		this.setUpEvents();
		this.handleOuterClick();
		$(this).trigger('loaded', this);
	}

	setUpElements(element){
		this.element = $(element);
		this.toggle = this.element.find('[data-toggle-button]');
		this.inner = this.element.find('[data-toggle-inner]')
		this.focusContext = this.element.find('.showInFocus');
		this.focusable = this.element.find(':focusable');
		this.link = this.element.find('.groupLink');
		this.loggedInLink = this.element.find('#mastnav .user > a');
		this.loggedinnavLinkEl = this.element.find('#loggedinnav > li a');
		this.loggedOutnavLinkEl = this.element.find('#mastnav li a');
		this.mastnavSearch = this.element.find('#mastsearch').find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
		this.tabIndexProp(this.loggedinnavLinkEl, -1);
		const mql = window.matchMedia("(max-width: 1023px)");
		if(mql.matches){
			this.tabIndexProp(this.mastnavSearch, -1);
			this.tabIndexProp(this.loggedOutnavLinkEl, -1);
		}
		// if($(window).width() < 1024){
		// 	this.tabIndexProp(this.mastnavSearch, -1);
		// 	this.tabIndexProp(this.loggedOutnavLinkEl, -1);
		// }
	}
	
	setUpEvents(){
		var self = this;
		this.toggle.on('click', function(evt){
			$(window).trigger('abacus:mastnav:triggered');
			self.toggleMenu();
			evt.preventDefault();
			$(self).trigger('toggle', self);
		});
		
		this.link.on('click', function(){
			self.hideOnFocus();
		});
		
		let focusable= this.loggedinnavLinkEl;
		let focusableSearch = this.mastnavSearch;
		let focusableLoggedOut = this.loggedOutnavLinkEl;
		
		this.focusInOut(focusable, self);
		this.focusInOut(focusableSearch, self);
		this.focusInOut(focusableLoggedOut, self);
			
		this.focusable.on('focus', function(evt){
			self.showOnFocus();
		});
		
		this.focusable.on('blur', function(evt){
			self.hideOnFocus();
		});

		this.loggedInLink.focus(function(){
			self.hideOnFocus();
		})
		
		this.loggedInLink.on('keydown', function(e){
			if (e.keyCode == '13'){
				self.showOnFocus();
			}
		})
	}

	focusInOut(element, selfElement){
		if(element.length){
			element.on('keydown', function(e) { 
				let firstEl = element[0];
				let lastEl = element[element.length - 1];
				/* shift + tab */
				if ( e.keyCode==9 && e.shiftKey)  {
					if (e.target === firstEl) {
						selfElement.hide();
					}
				} else if ( e.keyCode==9){
					if(e.target === lastEl) { 
						selfElement.hide();	 
					}
				}
			});
		}
	}
	tabIndexProp(element, tabIn){
		let loggedinnavLink = element;
		$(loggedinnavLink).each(function(i, link){
			link.tabIndex = tabIn;
		});
	}

	// mediaQuery(){	 
	// 	const mql = window.matchMedia("(max-width: 1023px)");
	// 	function tabIndexBreakpoint(e){
    //   	if (e.matches) {
	// 		this.tabIndexProp(self.mastnavSearch, -1);
	// 		this.tabIndexProp(self.loggedOutnavLinkEl, -1);
	// 	  }  
	// 	}
	// 	tabIndexBreakpoint(mql);
	// 	mql.trigger(tabIndexBreakpoint);
	// }

	toggleMenu(){
		if(this.isHidden()){
			this.show();
		} else {
			this.hide();
		}
	}
	
	isHidden(){
		return this.element.hasClass('hide');
	}
	
	

	hide(){
		const mql = window.matchMedia("(max-width: 1023px)");
		this.element.addClass('hide');
		this.element.removeClass('show');
		this.element.hasClass('mastheadSearch') ? $('body').removeClass('search-open') : '';
		this.element.hasClass('loggedout') ? $('body').removeClass('loggedoutuser-open') : '';
		this.element.hasClass('loggedin') ? $('body').removeClass('loggedinuser-open') : '';
		this.tabIndexProp(this.loggedinnavLinkEl, -1);
		if(mql.matches){
			this.tabIndexProp(this.mastnavSearch, -1);
			this.tabIndexProp(this.loggedOutnavLinkEl, -1);
		}
		
	}
	
	show(){
		this.element.removeClass('hide');
		this.element.addClass('show');
		this.element.hasClass('mastheadSearch') ? $('body').addClass('search-open') : '';
		this.element.hasClass('loggedout') ? $('body').addClass('loggedoutuser-open') : '';
		this.element.hasClass('loggedin') ? $('body').addClass('loggedinuser-open') : '';
		this.tabIndexProp(this.loggedinnavLinkEl, 0);
		this.tabIndexProp(this.mastnavSearch, 0);
		this.tabIndexProp(this.loggedOutnavLinkEl, 0);

	}
	
	hideOnFocus(){
		this.focusContext.addClass('hide');
		this.focusContext.removeClass('show');
	}
	
	showOnFocus(){
		this.focusContext.removeClass('hide');
		this.focusContext.addClass('show');
	}

	handleOuterClick(){
		var self = this;
		this.shouldOuterClick = this.element.attr('data-toggle-outer-click');

		if(this.shouldOuterClick) {
			$(document).on('click', function(evt){
				var $target = evt.target;
				var button = self.toggle[0];
				if(!($.contains(button, $target) || button === $target)) {
					self.hide();
				}
			});
		}
	}
}

class MultiToggleMenu extends Class {
	
	constructor(element, options){
		super();
		this.setUpElements(element);
		this.initToggles();
		this.setUpEvents();
		$(this).trigger('loaded', this);
	}
	
	setUpElements(element){
		this.element = $(element);
		this.$toggleItems = this.element.find('[data-multi-toggle-item]');
		this.focusable = this.element.find(':focusable');
	}
	
	initToggles(){
		this.toggleItems = this.$toggleItems.map(function(index, item){
			return new ToggleMenu(item);
		});
	}
	
	setUpEvents(){
		var self = this;
		$.each(this.toggleItems, function(index, item){
			$(item).on('toggle', function(e, context){
				self.onToggle(context);
			});
		});
	}
	
	onToggle(currentItem){
		$.each(this.toggleItems, function(index, item){
			if(item !== currentItem && !item.isHidden()){
				item.hide();
			}
		});
	}
}

export { ToggleMenu, MultiToggleMenu };


// WEBPACK FOOTER //
// ./Javascript/core/classes/menu/toggle.class.js